import React, {useState} from 'react';
import {View, Text, TouchableOpacity, StyleSheet, FlatList} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {globalImport} from '../../../common/globalImports';
import withLiveData from '../../../common/withLiveData';
import {giveCorrectPrice, isMobile} from '../../../utils/commonMethods';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../../utils/globalConstant';

const MultiOptionRow = ({
  index,
  event,
  handleMultiClickEvent,
  multiEventCurrentIndex,
  live,
}) => {
  const yPrice = live?.newYCP ?? event?.newYCP;
  const nPrice = live?.newNCP ?? event?.newNCP;
  return (
    <TouchableOpacity
      onPress={() => {
        handleMultiClickEvent(event.id, index);
      }}
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: index !== 0 ? 8 : 0
      }}>
      <View
        style={[!globalImport.isWeb ? {flex: 1, flexDirection: 'row'} : {}]}
        activeOpacity={0.8}>
        <View style={{marginRight: 10}}>
          <Text
            style={{...globalFontStyle.appFontHeading, color: globalConfigurableData.primaryTextColor}}
            numberOfLines={2}>
            {event.alternate_title}
          </Text>
        </View>
        <View style={{flex: 1}}></View>
      </View>
      <View style={{flex: 1, flexDirection: 'row', justifyContent: 'flex-end'}}>
        <TouchableOpacity
          onPress={() => {
            isMobile()
              ? handleMultiClickEvent(event.id, index, 'yes')
              : handleMultiClickEvent(event.id, index);
          }}
          style={[
            styles.bottomButtonStyles,
            {marginRight: 10, backgroundColor: GlobalScreens.Home.yesBtnBlock},
          ]}>
          <FormTextLabel
            label={'Yes'}
            labelStyles={{
              ...globalFontStyle.appFontBody,
              color: GlobalScreens.Home.yesBtnTxt,
            }}
          />
          <Text
            style={{...globalFontStyle.appFontHeading, color: GlobalScreens.Home.yesBtnTxt}}>
            {yPrice ? '  ' + giveCorrectPrice({yPrice: yPrice}) : '  -'}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={e => {
            isMobile()
              ? handleMultiClickEvent(event.id, index, 'no')
              : handleMultiClickEvent(event.id, index);
          }}
          style={styles.bottomButtonStyles}>
          <FormTextLabel
            label={'No'}
            labelStyles={{
              ...globalFontStyle.appFontBody,
              color: GlobalScreens.Home.noBtnTxt,
            }}
          />
          <Text
            style={{...globalFontStyle.appFontHeading, color: GlobalScreens.Home.noBtnTxt}}>
            {nPrice ? '  ' + giveCorrectPrice({nPrice: nPrice}) : '  -'}
          </Text>
        </TouchableOpacity>
      </View>
    </TouchableOpacity>
  );
};

const getEventId = props => props?.event?.id;
export default withLiveData(getEventId)(MultiOptionRow);

const styles = StyleSheet.create({
  categoryStyle: {
    paddingHorizontal: 18,
    paddingVertical: 7,
    borderColor: Colors.bgWhite,
    borderWidth: 0,
  },
  categoryStyleSelected: {
    backgroundColor: Color.black,
    color: Color.bgWhite,
  },
  bottomButtonStyles: {
    paddingHorizontal: 15,
    paddingVertical: 4,
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 5,
    justifyContent: 'center',
    backgroundColor: GlobalScreens.Home.noBtnBlock,
  },
});
